"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallText = exports.LargeText = exports.CardContainer = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"h1ylya00";
const CardContainer = exports.CardContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "CardContainer",
  class: "c1orq49n",
  vars: {
    "c1orq49n-0": [props => props.backgroundColor]
  }
});
const LargeText = exports.LargeText = /*#__PURE__*/(0, _react.styled)("div")({
  name: "LargeText",
  class: "l11x4ix3",
  vars: {
    "l11x4ix3-0": [({
      fontSize
    }) => fontSize ? `${fontSize}rem` : '8.2rem'],
    "l11x4ix3-1": [({
      fontSize
    }) => fontSize ? `${fontSize + 0.2}rem` : '8.2rem'],
    "l11x4ix3-2": [props => props.textColor],
    "l11x4ix3-3": [({
      fontSize
    }) => fontSize ? `${fontSize * 0.75}rem` : '6.15rem'],
    "l11x4ix3-4": [({
      fontSize
    }) => fontSize ? `${fontSize * 0.75 + 0.2}rem` : '6.35rem']
  }
});
const SmallText = exports.SmallText = /*#__PURE__*/(0, _react.styled)("div")({
  name: "SmallText",
  class: "s1ebkx95",
  vars: {
    "s1ebkx95-0": [props => props.smallTextColor]
  }
});